import cn from 'classnames'
import React from 'react'

import { testProps } from 'utils/test/qaData'

import * as s from './Group.module.scss'

type Child = Child[] | React.ReactElement | JSX.Element | boolean | null | undefined

/**
 * Props for the Group component.
 */
interface IGroupProps {
  /**
   * The child elements of the button group.
   */
  children?: Child
  join?: boolean
  vertical?: boolean
  testData?: string
  gap?: number
  fluid?: boolean
}

const Group = <P extends { style: React.CSSProperties }>(
  { children, join, vertical, testData, gap, fluid }: IGroupProps,
  ref: React.Ref<HTMLDivElement>,
) => {
  const childrenArray = React.Children.toArray(children).filter(React.isValidElement<P>)
  return (
    <div
      {...testProps({ testData })}
      className={cn(s.root, {
        [s.join]: join,
        [s.vertical]: vertical,
        [s.isGap]: gap,
        [s.fluid]: fluid,
      })}
      ref={ref}
      style={{ gap }}
    >
      {childrenArray}
    </div>
  )
}

Group.displayName = 'Group'

export default React.forwardRef(Group) as (
  props: IGroupProps & { ref?: React.Ref<HTMLDivElement> },
) => React.ReactElement
